import { env } from 'config';
import { Deeplink, QueryParams } from 'types';
import { apiUtils } from 'utils';

import { createCrudApi } from './crud.api';

const url = `${env.apiUrl}/deeplinks`;

const getAllByTradeMethodId =
  (id: string) =>
  async (params?: QueryParams): Promise<Deeplink[]> =>
    (await apiUtils.getWithQueryParams(`${url}/trade-method/${id}`, params))
      .data;

export const deeplinksApi = {
  ...createCrudApi<Deeplink>('/deeplinks'),
  getAllByTradeMethodId,
};
